import type { Category } from 'api/categories/useBrandCategories';
import type { Vibe } from 'api/vibes/useBrandVibes';

const SCHEDULE_VIEW_ITEM_COUNT = 4;

const resolveFilterItemCount = (
  items: (Category | Vibe)[],
  isMobile: boolean,
  isResults: boolean,
  showScheduleView: boolean,
) => {
  const baseCount = (() => {
    if (showScheduleView) return SCHEDULE_VIEW_ITEM_COUNT;
    if (isMobile) {
      return isResults ? 6 : 2;
    }
    return isResults ? items.length : 3;
  })();
  // A "More" control hiding a single item costs a click for nothing — show it inline instead.
  return items.length === baseCount + 1 ? items.length : baseCount;
};

export default resolveFilterItemCount;
